class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.hoverCloseDelay = 150;
    this.hoverCloseTimer = null;
    this.closeAnimationDuration = 500;
    this.closeAnimationTimer = null;

    this.mainDetailsToggle.addEventListener('mouseenter', this.onHoverIntent.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.onHoverEnd.bind(this));
    this.content.addEventListener('mouseenter', this.onHoverIntent.bind(this));
    this.content.addEventListener('mouseleave', this.onHoverEnd.bind(this));
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  onHoverIntent() {
    if (!this.isDesktop()) return;
    clearTimeout(this.hoverCloseTimer);
    clearTimeout(this.closeAnimationTimer);
    if (this.mainDetailsToggle.open && this.mainDetailsToggle.classList.contains('menu-opening')) return;

    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this && menu.mainDetailsToggle && menu.mainDetailsToggle.open) {
        menu.close();
      }
    });

    this.mainDetailsToggle.open = true;

    // Adding the open styles a tick after the `open` attribute lets the
    // browser first paint the details content in its closed (display:none ->
    // block) state, so the opacity/transform change right after actually
    // transitions instead of jumping straight to its end state.
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
  }

  onHoverEnd() {
    if (!this.isDesktop()) return;
    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => this.close(), this.hoverCloseDelay);
  }

  close() {
    if (!this.mainDetailsToggle.hasAttribute('open')) return;

    clearTimeout(this.hoverCloseTimer);
    clearTimeout(this.closeAnimationTimer);
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);

    this.closeAnimationTimer = setTimeout(() => {
      this.mainDetailsToggle.removeAttribute('open');
    }, this.closeAnimationDuration);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
